import * as React from 'react';
import useIsomorphicLayoutEffect from './useIsomorphicLayoutEffect';

/**
 * React Hook that returns the current window size
 * and report updates from the 'resize' window event
 *
 * @typedef {useIsMobile} useIsMobile
 * @property {number} isWider Window width judgment...
 * @returns {isWider} A value representing whether the width is less than 768
 */

const useIsWiderThan = (width: number): boolean => {
    const initialWidth =
        // @ts-ignore // get width from
        (typeof global !== 'undefined' && global.width) ||
        // @ts-ignore
        (typeof window !== 'undefined' && window?.__data?.windowSize?.width) ||
        1024;

    const [isWider, setIsWider] = React.useState(initialWidth > width);

    useIsomorphicLayoutEffect(() => {
        setIsWider(window.innerWidth > width);
    }, []);

    const handleResize = React.useCallback(() => {
        if (isWider !== window.innerWidth > width) {
            setIsWider(window.innerWidth > width);
        }
    }, [isWider, width]);

    React.useEffect(() => {
        // Add event listener for window resize events
        window.addEventListener('resize', handleResize);
        window.addEventListener('orientationchange', handleResize);

        // Remove event listener
        return () => {
            window.removeEventListener('resize', handleResize);
            window.removeEventListener('orientationchange', handleResize);
        };
    });

    return isWider;
};

export default useIsWiderThan;
